export * from './accountMobile.service';
import { AccountMobileService } from './accountMobile.service';
export * from './analyticalCodeTypes.service';
import { AnalyticalCodeTypesService } from './analyticalCodeTypes.service';
export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './basicDataMobile.service';
import { BasicDataMobileService } from './basicDataMobile.service';
export * from './contributionOrWithdrawalTypes.service';
import { ContributionOrWithdrawalTypesService } from './contributionOrWithdrawalTypes.service';
export * from './creditCard.service';
import { CreditCardService } from './creditCard.service';
export * from './datafeedMobile.service';
import { DatafeedMobileService } from './datafeedMobile.service';
export * from './eDocumentMobile.service';
import { EDocumentMobileService } from './eDocumentMobile.service';
export * from './generalOrderMobileAPI.service';
import { GeneralOrderMobileAPIService } from './generalOrderMobileAPI.service';
export * from './mandateType.service';
import { MandateTypeService } from './mandateType.service';
export * from './performanceMobile.service';
import { PerformanceMobileService } from './performanceMobile.service';
export * from './portfolioMobile.service';
import { PortfolioMobileService } from './portfolioMobile.service';
export * from './portfolioType.service';
import { PortfolioTypeService } from './portfolioType.service';
export * from './securities.service';
import { SecuritiesService } from './securities.service';
export * from './stockMarketOrderAPI.service';
import { StockMarketOrderAPIService } from './stockMarketOrderAPI.service';
export * from './themingMobile.service';
import { ThemingMobileService } from './themingMobile.service';
export * from './thirdpartyMobile.service';
import { ThirdpartyMobileService } from './thirdpartyMobile.service';
export * from './transferOrder.service';
import { TransferOrderService } from './transferOrder.service';
export * from './valuationMobile.service';
import { ValuationMobileService } from './valuationMobile.service';
export const APIS = [AccountMobileService, AnalyticalCodeTypesService, AuthenticationService, BasicDataMobileService, ContributionOrWithdrawalTypesService, CreditCardService, DatafeedMobileService, EDocumentMobileService, GeneralOrderMobileAPIService, MandateTypeService, PerformanceMobileService, PortfolioMobileService, PortfolioTypeService, SecuritiesService, StockMarketOrderAPIService, ThemingMobileService, ThirdpartyMobileService, TransferOrderService, ValuationMobileService];
